import { ProductTemplateAsSalzburgProps } from "@made-people/blueprint-product";
import { ChevronLeft } from "../../../../assets/icons/ChevronLeft";
import { ChevronRight } from "../../../../assets/icons/ChevronRight";
import { MMProductDeliveryStatus } from "../../../features/delivery-status/mm-product-delivery-status";

export const ProductTemplateAsSalzburg = {
  template: "salzburg",
  sizePickerSettings: {
    template: "modal",
    aboveButtonComponent: <MMProductDeliveryStatus />,
    buttonVariants: {
      style: "solid",
      width: { initial: "full", lg: "auto" },
    },
  },
  siblingsPickerSettings: {
    template: "color-swatch",
    colorSwatchAttributeKey: "product_color_image_url",
  },
  imageGallerySettings: {
    template: "keen",
    indicator: "dots",
    navigation: {
      enabled: {
        mobile: true,
        tablet: true,
        desktop: true,
      },
      prevIcon: <ChevronLeft />,
      nextIcon: <ChevronRight />,
    },
    slidesPerView: {
      mobile: 1,
      tablet: 1.3,
      desktop: 1.5,
    },
    gap: {
      mobile: 0,
      tablet: 0,
      desktop: 0,
    },
  },
} satisfies ProductTemplateAsSalzburgProps;
